let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8qZjs")).then(() => parcelRequire('471XU'));